import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface ViewContainerProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

export default function ViewContainer({ title, onClose, children }: ViewContainerProps) {
  return (
    <Paper sx={{ 
      width: '100%', 
      p: 2, 
      border: '1px solid', 
      borderColor: 'divider',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100vh - 180px)',
      // Явно задаем фон, как просили
      backgroundImage: "linear-gradient(to bottom right, #262626e6, #171717b3)",
      backdropFilter: "blur(10px)",
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexShrink: 0 }}>
        <Typography variant="h6" component="h1">
          {title}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ 
        overflowY: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
      }}>
        {children}
      </Box>
    </Paper>
  );
}
